import Dashboard from '../DashboardAnalytics/Dashboard.tsx';

const DashboardAnalytics = () => {
  return (
    <div>
      <Dashboard />
    </div>
  );
};

export default DashboardAnalytics;
